"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _containers = require("../containers");
var _components = require("../components");
var _factories = require("../../../factories");
var _Forms = require("../../../components/Forms");
var _usersDeprecated = require("../../users-deprecated");
var _components2 = require("../../../components");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const fields = {
  fields: [{
    key: 'GivenName'
  }, {
    key: 'FamilyName'
  }]
};
const EditPicture = props => {
  const {
    me
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Forms.RelationPicture, {
    value: me.data.UserImage,
    schema: _usersDeprecated.schema.UserImage,
    row: {
      Id: me.data.Id
    }
  });
};
const Account = props => {
  const {
    me
  } = props.auth;
  if (!me.fetched) return /*#__PURE__*/_react.default.createElement(_components2.Spinner, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'container-fluid justify-content-left mt-5'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-narrow"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex mb-4'
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: 'page-title ml-0'
  }, "Profile")), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_containers.EditMe, {
    me: me
  }, /*#__PURE__*/_react.default.createElement(_factories.EditFormFactory, {
    schema: _usersDeprecated.schema,
    fields: fields
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Picture"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_containers.EditMe, {
    me: me
  }, /*#__PURE__*/_react.default.createElement(EditPicture, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Password"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_containers.UpdatePassword, null, /*#__PURE__*/_react.default.createElement(_components.UpdatePasswordForm, null))))))), /*#__PURE__*/_react.default.createElement(_components2.ImprintLink, null));
};
EditPicture.propTypes = process.env.NODE_ENV !== "production" ? {
  me: _propTypes.default.object
} : {};
Account.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: _propTypes.default.object,
  me: _propTypes.default.object
} : {};
var _default = exports.default = Account;
module.exports = exports.default;